import Point001Image from './point-001.webp'
import Point002Image from './point-002.webp'
import Point003Image from './point-003.webp'
import Point004Image from './point-004.webp'

export { Point001Image, Point002Image, Point003Image, Point004Image }
